// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","274":"0a533994","458":"ab695515","565":"2bead3d5","577":"66801e42","652":"34876035","682":"d5252985","771":"e1300a72","783":"c66ca607","812":"e16e9c63","867":"b0ebb319","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};